export default "__VITE_ASSET__CTfiX02I__"